import SignaturePad from "./signature_pad";

export function clearPad(signaturePad: SignaturePad|null) {
  signaturePad && signaturePad.clear();
}

export function resizeCanvas(canvas: any, signaturePad: SignaturePad|null) {
  if (!canvas || !signaturePad) {
    return;
  }
  const ratio = Math.max(window.devicePixelRatio || 1, 1);
  canvas.width = canvas.offsetWidth * ratio;
  canvas.height = canvas.offsetHeight * ratio;
  canvas.getContext("2d").scale(ratio, ratio);
  signaturePad.clear(); // otherwise isEmpty() might return incorrect value
}
